// Shared fetch helper + formatting utils for the Support portal.
// All Support endpoints are GET + Bearer token. A 401 means the session expired;
// we surface that to the caller's onAuthFail so the shell can force re-login.

import { downloadWithProgress } from '../../common/downloadWithProgress';

export const API_URL = process.env.REACT_APP_API_URL;

export async function supportFetch(path, token, onAuthFail) {
  const res = await fetch(`${API_URL}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (res.status === 401) {
    if (onAuthFail) onAuthFail();
    throw new Error('Session expired');
  }
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

// Authenticated file download with progress. Delegates to the shared streaming
// helper (which streams the body and reports a percentage) while keeping the
// Support portal's 401 → onAuthFail re-login behavior. Pass onProgress to receive
// 0..100 (or null when the file size is unknown).
export async function supportDownload(path, token, onAuthFail, onProgress) {
  const { ok, status } = await downloadWithProgress(
    `${API_URL}${path}`,
    path.split('/').pop() || 'download',
    { headers: { Authorization: `Bearer ${token}` }, onProgress }
  );
  if (status === 401) {
    if (onAuthFail) onAuthFail();
    throw new Error('Session expired');
  }
  if (!ok) throw new Error(`HTTP ${status}`);
}

export function fmtBytes(n) {
  if (n == null) return '—';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let v = Number(n);
  let i = 0;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i++; }
  return `${v.toFixed(v < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}

export function fmtDate(d) {
  if (!d) return '—';
  const dt = new Date(d);
  return isNaN(dt) ? String(d) : dt.toLocaleString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

export function fmtNum(n) {
  return n == null ? '—' : Number(n).toLocaleString('en-US');
}
